// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { Gender, AuthorListView } from "../schema";
import { serialize_Gender_internal, deserialize_Gender_internal } from "./Gender";

export function serialize_AuthorListView_internal(value: AuthorListView): unknown {
  return ((value: { authorId: number; firstName: string | null; gender: Gender | null; lastName: string | null; middleName: string | null }): unknown => {
    return {
      authorId: ((value: number): unknown => {
        return value;
      })(value["authorId"]),
      firstName: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["firstName"]),
      gender: ((value: Gender | null): unknown => {
        if (value === null) {
          return null;
        }
        return serialize_Gender_internal(value);
      })(value["gender"]),
      lastName: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["lastName"]),
      middleName: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["middleName"]),
    };
  })(value);
}
export function serialize_AuthorListView(obj: AuthorListView): string {
  return renderJsonWithNumbersAsBigint(serialize_AuthorListView_internal(obj));
}
export function deserialize_AuthorListView_internal(value: unknown): ParserResult<AuthorListView> {
  return ((
    value: unknown,
  ): ParserResult<{
    authorId: number;
    firstName: string | null;
    gender: Gender | null;
    lastName: string | null;
    middleName: string | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AuthorListView]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AuthorListView]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "authorId")) {
      return { success: false, reason: `[#/components/schemas/AuthorListView/authorId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'authorId'.` };
    }
    const parsed_authorId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/AuthorListView/authorId]: '${value}' expected to be of type number.` };
      })(value["authorId"]);
    })();
    if (!parsed_authorId.success) {
      return { success: false, reason: parsed_authorId.reason };
    }
    if (!hasProp(value, "firstName")) {
      return { success: false, reason: `[#/components/schemas/AuthorListView/firstName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstName'.` };
    }
    const parsed_firstName = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AuthorListView/firstName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["firstName"]);
    })();
    if (!parsed_firstName.success) {
      return { success: false, reason: parsed_firstName.reason };
    }
    if (!hasProp(value, "gender")) {
      return { success: false, reason: `[#/components/schemas/AuthorListView/gender]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'gender'.` };
    }
    const parsed_gender = ((): ParserResult<Gender | null> => {
      return ((value: unknown): ParserResult<Gender | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return deserialize_Gender_internal(value);
      })(value["gender"]);
    })();
    if (!parsed_gender.success) {
      return { success: false, reason: parsed_gender.reason };
    }
    if (!hasProp(value, "lastName")) {
      return { success: false, reason: `[#/components/schemas/AuthorListView/lastName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastName'.` };
    }
    const parsed_lastName = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AuthorListView/lastName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["lastName"]);
    })();
    if (!parsed_lastName.success) {
      return { success: false, reason: parsed_lastName.reason };
    }
    if (!hasProp(value, "middleName")) {
      return { success: false, reason: `[#/components/schemas/AuthorListView/middleName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'middleName'.` };
    }
    const parsed_middleName = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AuthorListView/middleName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["middleName"]);
    })();
    if (!parsed_middleName.success) {
      return { success: false, reason: parsed_middleName.reason };
    }
    return { success: true, value: { authorId: parsed_authorId.value, firstName: parsed_firstName.value, gender: parsed_gender.value, lastName: parsed_lastName.value, middleName: parsed_middleName.value } };
  })(value);
}
export function deserialize_AuthorListView(str: string): ParserResult<AuthorListView> {
  return deserialize_AuthorListView_internal(parseJsonWithNumbersAsBigint(str));
}
